import { useStore } from "@nanostores/react"

import { persistentAtom } from "@nanostores/persistent"

const clarificationRequestHintClosedAtom = persistentAtom<boolean>(
  "clarification-request-hint-closed",
  false,
  {
    encode: value => (value === undefined ? "" : JSON.stringify(value)),
    decode: str => (str === "" ? undefined : JSON.parse(str))
  }
)

export function setPersistentClarificationRequestHintClosed(
  value: boolean
): void {
  clarificationRequestHintClosedAtom.set(value)
}

export function usePersistentClarificationRequestHintClosed():
  | boolean
  | undefined {
  return useStore(clarificationRequestHintClosedAtom)
}
